module.exports = __webpack_public_path__ + "ipetbooking-landing/img/logo-menu.80d87eb7.svg";